import * as S from './styles';
import { PageBanner } from 'base/src/components/PageBanner/index';
import { RootStateCarteira } from '../../store/carteiraReducer';
import { useEffect } from 'react';
import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { GetExtrato } from '../../store/extrato/actions/extratoAction';
import ExtratoList from './components/ExtratoList';
import NoData from 'base/src/components/NoData';
// import Home from '../Home';

const connector = connectUtil(
  (state: RootStateCarteira) => ({
    ExtratoRange: state.ExtratoReducer.Extrato,
    CarteiraUsuario: state.CarteiraBaseReducer.CarteiraUsuario,
    HomeInfo: state.CarteiraBaseReducer.CarteiraBase,
  }),
  { GetExtrato }
);

export interface ExtratoComponentProps extends PropsFromRedux<typeof connector> {
}

function Extrato(props: ExtratoComponentProps){
  const fromDate = '';
  const toDate = '';

  const request = {
    From: fromDate,
    To: toDate,
  };

  useEffect(() => {
    props.GetExtrato(request, props.CarteiraUsuario[0].CarteiraID, () => { });
  }, [])

  return (
    <S.Container>
      <PageBanner title='Extrato' subtile='Histórico de pagamento(s) e depósito(s)' />
      {
        props.ExtratoRange === undefined || props.ExtratoRange.length < 1 ? (
          <NoData/>
        ):
      (
        <ExtratoList extrato={props.ExtratoRange} hideValues={props.HomeInfo.EsconderSaldo} />
      )
      }
      
    </S.Container>
  )
}

export default connector(Extrato);
